<template>
  <div id="mmp-navbar">
    <nav :class="['sidebar-navigation', { collapsed }]">
      <ul class="nav-scroll-list">
        <li class="my-3 mx-2 logo-container">
          <a href="https://dmp-maps.com/" target="_blank">
            <img src="../../assets/dmpLogo.png" alt="Banner" class="logo" />
          </a>
          <span class="ml-1 label">Dynamic Map Platform</span>
          <span v-if="versionReleaseInfo" class="ml-1 label version-label">MMP - Version {{ versionReleaseInfo.version }}</span>
        </li>

        <li :class="{ active: currentPage === 'Dashboard' }"
            @click="handleDashboardNav"
            :title="collapsed ? 'Dashboard' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'home']"></fa></span>
            <span class="label">Dashboard</span>
          </div>
        </li>

        <!-- Acquisitions -->
        <li
          v-if="globalIsUserAllowed('Acquisitions')"
          class="has-submenu"
          :class="{ open: groups.acquisitions && !collapsed }"
        >
          <div
            class="text_format group-row"
            @click="toggleGroup('acquisitions')"
            :title="collapsed ? 'Acquisitions' : null"
          >
            <span class="group-row-main">
              <span class="nav-icon"><fa :icon="['fas', 'clipboard-list']"></fa></span>
              <span class="label">Acquisitions</span>
            </span>
            <span class="nav-icon submenu-caret" v-if="!collapsed">
              <fa :icon="['fas', 'angle-right']"></fa>
            </span>
          </div>
          <ul class="submenu">
            <li v-if="globalIsUserAllowed('DPR')" class="submenu-item" @click="loadProjectAction('Daily Productivity Report')">
              <div class="text_format">
                <span class="label">Daily Productivity Report</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('Entry_Manager')" class="submenu-item" @click="showModal('entryManagerModal')">
              <div class="text_format">
                <span class="label">Entry Manager</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('DPR_Reports')" class="submenu-item" @click="showModal('reportsModal')">
              <div class="text_format">
                <span class="label">Reports</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('DPR_Admin_Console')" class="submenu-item" @click="showModal('adminConsoleModal')">
              <div class="text_format">
                <span class="label">Admin Console</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('GTP_Tracking')" class="submenu-item" @click="showModal('gtpModal')">
              <div class="text_format">
                <span class="label">GTP Tracking</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('GTP_Report')" class="submenu-item" @click="showModal('gtpReportModal')">
              <div class="text_format">
                <span class="label">GTP Report</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('Field_Images')" class="submenu-item" @click="showModal('imageCarousel')">
              <div class="text_format">
                <span class="label">Field Images</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('EOD')" class="submenu-item" @click="loadProjectAction('EodFieldReview', true)">
              <div class="text_format">
                <span class="label">EOD Field Trail Review</span>
              </div>
            </li>
          </ul>
        </li>

        <li v-if="globalIsUserAllowed('DRT')"
            :class="{ active: currentPage === 'DRT' }"
            @click="handleToolNav('DRT', 'Delivery Review Tool')"
            :title="collapsed ? 'Delivery Review Tool' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'history']"></fa></span>
            <span class="label">Delivery Review Tool</span>
          </div>
        </li>

        <li v-if="globalIsUserAllowed('ANSI')"
            :class="{ active: currentPage === 'ANSI' }"
            @click="handleToolNav('ANSI', 'ANSI')"
            :title="collapsed ? 'ANSI' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'route']"></fa></span>
            <span class="label">ANSI</span>
          </div>
        </li>

        <!-- Hard Drive Tracking -->
        <li
          v-if="globalIsUserAllowed('Hard_Drive_Tracking_Menu')"
          class="has-submenu"
          :class="{ open: groups.hdt && !collapsed }"
        >
          <div
            class="text_format group-row"
            @click="toggleGroup('hdt')"
            :title="collapsed ? 'Hard Drive Tracking' : null"
          >
            <span class="group-row-main">
               <span class="nav-icon"><fa :icon="['fas', 'hdd']"></fa></span>
              <span class="label">Hard Drive Tracking</span>
            </span>
            <span class="nav-icon submenu-caret" v-if="!collapsed">
              <fa :icon="['fas', 'angle-right']"></fa>
            </span>
          </div>
          <ul class="submenu">
            <li v-if="globalIsUserAllowed('Hard_Drive_Tracking')" class="submenu-item" @click="loadProjectAction('Hard Drive Tracking')">
              <div class="text_format">
                <span class="label">Hard Drive Tracking</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('HDT_Admin_Console')" class="submenu-item" @click="$emit('initHDTAdminConsole')">
              <div class="text_format">
                <span class="label">Admin Console</span>
              </div>
            </li>
          </ul>
        </li>

        <li v-if="globalIsUserAllowed('Vehicles')" @click="showModal('fleetioVehiclesModal')" :title="collapsed ? 'Vehicle Status' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'truck']"></fa></span>
            <span class="label">Vehicle Status</span>
          </div>
        </li>

        <li v-if="globalIsUserAllowed('Work_Management_System')" @click="showModal('WMSModal')" :title="collapsed ? 'Work Management System' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'clipboard-check']"></fa></span>
            <span class="label">Work Management System</span>
          </div>
        </li>

        <li v-if="globalIsUserAllowed('WCL')"
            :class="{ active: currentPage === 'WCL' }"
            @click="handleToolNav('WCL', 'WCL')"
            :title="collapsed ? 'WCL' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'road']"></fa></span>
            <span class="label">WCL</span>
          </div>
        </li>

        <li v-if="globalIsUserAllowed('Data_Tools')" @click="loadProjectAction('DDT')" :title="collapsed ? 'Data Tools' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'database']"></fa></span>
            <span class="label">Data Tools</span>
          </div>
        </li>

        <li v-if="globalIsUserAllowed('Sales')" @click="loadProjectAction('Sales')" :title="collapsed ? 'Sales' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'chart-line']"></fa></span>
            <span class="label">Sales</span>
          </div>
        </li>

        <li v-if="globalIsUserAllowed('Spatial_Intelligence')" @click="loadProjectAction('Spatial_Intelligence')" :title="collapsed ? 'Spatial Intelligence' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'globe-americas']"></fa></span>
            <span class="label">Spatial Intelligence</span>
          </div>
        </li>

        <li
          v-if="globalIsUserAllowed('UAC')"
          class="has-submenu"
          :class="{ open: groups.uac && !collapsed }"
        >
          <div
            class="text_format group-row"
            @click="toggleGroup('uac')"
            :title="collapsed ? 'Admin Features' : null"
          >
            <span class="group-row-main">
               <span class="nav-icon"><fa :icon="['fas', 'cog']"></fa></span>
              <span class="label">Admin Features</span>
            </span>
            <span class="nav-icon submenu-caret" v-if="!collapsed">
              <fa :icon="['fas', 'angle-right']"></fa>
            </span>
          </div>
          <ul class="submenu">
            <li v-if="globalIsUserAllowed('UAC')" class="submenu-item" @click="$bvModal.show('UACModal')">
              <div class="text_format">
                <span class="label">User Account Control</span>
              </div>
            </li>
            <li v-if="globalIsUserAllowed('Access_Control')" class="submenu-item" @click="$bvModal.show('AccessControlModal')">
              <div class="text_format">
                <span class="label">Access Control</span>
              </div>
            </li>
             <li v-if="globalIsUserAllowed('Release_Version')" class="submenu-item" @click="$bvModal.show('versionReleaseModal')">
              <div class="text_format">
                <span class="label">Release Version</span>
              </div>
            </li>
             <li v-if="globalIsUserAllowed('MMP_Deliveries')" class="submenu-item" @click="$bvModal.show('deliveriesModal')">
              <div class="text_format">
                <span class="label">MMP Deliveries</span>
              </div>
            </li>
             <li v-if="globalIsUserAllowed('Automate_Scripts')" class="submenu-item" @click=" $bvModal.show('DPRScripts')">
              <div class="text_format">
                <span class="label">DPR Automation</span>
              </div>
            </li>
              <li v-if="globalIsUserAllowed('Automate_Scripts')" class="submenu-item" @click=" $bvModal.show('ScriptSettings')">
              <div class="text_format">
                <span class="label">DRT / ANSI Automation</span>
              </div>
            </li>
          </ul>
        </li>

        <li v-if="mapsMode" @click="signOut" class="logout" :title="collapsed ? 'Sign Out' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'sign-out-alt']"></fa></span>
            <span class="label">Sign Out</span>
          </div>
        </li>
      </ul>
      <ul class="nav-collapse-list">
        <li class="nav-collapse-toggle" @click="toggleCollapse" :title="collapsed ? 'Expand sidebar' : 'Collapse sidebar'">
          <div class="nav-toggle-inner">
            <span class="nav-toggle-btn" :class="{ collapsed }">
              <fa :icon="['fas', 'angle-left']" class="nav-toggle-icon"></fa>
            </span>
            <span class="nav-toggle-text label">Collapse</span>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MMP_NavBar',
  props: ['mapsMode', 'versionReleaseInfo'],
  data() {
    return {
      collapsed: false,
      currentPage: 'Dashboard',
      groups: {
        acquisitions: false,
        hdt: false,
        uac: false
      }
    }
  },
  computed: {
    ...mapGetters(['globalIsUserAllowed'])
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed
    },
    toggleGroup(name) {
      if (this.collapsed) {
        // Expand the whole sidebar first — a submenu can't show while collapsed,
        // so a click here means "show me my options," not just "toggle."
        this.collapsed = false
        this.groups[name] = true
      } else {
        this.groups[name] = !this.groups[name]
      }
    },
    handleDashboardNav() {
      this.currentPage = 'Dashboard'
      this.$emit('showDashboard')
    },
    // DRT/ANSI/WCL take over the role the old generic "Map" button used to:
    // switch into the map view and load that specific tool.
    handleToolNav(page, projectName) {
      this.currentPage = page
      this.collapsed = true
      this.$emit('navAction', { project: projectName, showMap: true })
    },
    loadProjectAction(projectName, showMap = false) {
      this.$emit('navAction', { project: projectName, showMap })
    },
    showModal(modalId) {
      this.$bvModal.show(modalId)
    },
    signOut() {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
      this.$emit('clearCurrentPositionsInterval')
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
#mmp-navbar {
  position: relative;
  flex-shrink: 0;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#mmp-navbar .label {
  font-weight: 400;
  font-size: 0.82rem;
  letter-spacing: 0.1px;
}

#mmp-navbar .logo-container .label {
  font-weight: 500;
  font-size: 0.86rem;
  letter-spacing: -0.1px;
}

#mmp-navbar .logo-container .version-label {
  display: block;
  font-weight: 400;
  font-size: 0.68rem;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 0.02em;
}

#mmp-navbar .submenu-item .label {
  font-weight: 300;
  font-size: 0.76rem;
}

.nav-collapse-toggle {
  padding: 10px 0 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.nav-collapse-toggle:hover {
  background-color: rgba(6, 47, 86, 0.65) !important;
}

.nav-toggle-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.nav-toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(152, 215, 236, 0.25);
  transition: background 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease, transform 0.35s ease;
}

/* Chevron points left when expanded, flips to point right when collapsed. */
.nav-toggle-btn.collapsed {
  transform: rotate(180deg);
}

/* Hover styling deliberately avoids `transform` so the collapsed rotation
   above is never clobbered by specificity. */
.nav-collapse-toggle:hover .nav-toggle-btn {
  background: rgba(152, 215, 236, 0.18);
  border-color: rgba(152, 215, 236, 0.6);
  box-shadow: 0 0 0 3px rgba(152, 215, 236, 0.08);
}

.nav-toggle-icon {
  font-size: 0.8rem;
  color: #cce8f5;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.nav-collapse-toggle:hover .nav-toggle-icon {
  opacity: 1;
}

.nav-toggle-text {
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #98d7ec;
  opacity: 0.7;
}

.sidebar-navigation {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100vh;
  max-height: 100vh;
  width: 15rem;
  background: linear-gradient(180deg, #0a2d52 0%, #063c6d 40%, #04294d 100%);
  transition: width 0.5s ease;
  text-align: right;
  overflow: hidden;
  flex-shrink: 0;
  vertical-align: top;
}

.sidebar-navigation.collapsed {
  width: 4.375rem !important;
}

.sidebar-navigation ul {
  text-align: center;
  color: whitesmoke;
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

/* Menu items scroll independently; the collapse toggle (below) never does. */
.nav-scroll-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.nav-collapse-list {
  flex: 0 0 auto;
}

.sidebar-navigation ul li {
  padding: 16px 0;
  cursor: pointer;
  transition: all ease-out 120ms;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: whitesmoke;
  flex: 0 0 auto;
}

.sidebar-navigation ul li:hover {
  background-color: rgba(6, 47, 86, 0.65);
}

.sidebar-navigation ul li.active {
  background-color: rgba(6, 47, 86, 0.65);
}

.sidebar-navigation ul li.active .nav-icon {
  color: #98d7ec;
}

.sidebar-navigation.collapsed ul li .label {
  display: none;
}

.label {
  white-space: nowrap;
  overflow: hidden;
  transition: opacity 0.3s ease, margin 0.3s ease;
}

.collapsed .label {
  opacity: 0;
  margin-left: 0;
  pointer-events: none;
}

.text_format {
  display: flex;
  align-items: center;
  text-align: left;
  margin-left: var(--sidebar-item-indent, 26px);
}

/* Collapsed rail: center the 20px icon column in the rail's width */
.sidebar-navigation.collapsed .text_format {
  margin-left: calc((4.375rem - 20px) / 2);
}

/* Fixed-width icon column so every icon renders the same size and every
   label starts at the same horizontal offset, regardless of glyph width. */
.nav-icon {
  display: inline-flex;
  flex: 0 0 20px;
  width: 20px;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.text_format .label {
  margin-left: 12px;
}

.group-row {
  justify-content: space-between;
  margin-right: 14px;
}

.group-row-main {
  display: flex;
  align-items: center;
  min-width: 0;
}

.submenu-caret {
  flex: 0 0 16px;
  width: 16px;
  font-size: 0.85rem;
  opacity: 0.6;
  transition: opacity 0.2s ease, transform 0.25s ease;
}

.has-submenu.open .submenu-caret {
  opacity: 1;
  transform: rotate(90deg);
}

/* ── Animated accordion submenu (matches DT_NavBar) ─────────── */
.has-submenu {
  padding: 0 !important;
}

.has-submenu > .text_format.group-row {
  padding: 16px 0;
  cursor: pointer;
}

.has-submenu > .text_format.group-row:hover {
  background-color: rgba(6, 47, 86, 0.65);
}

.sidebar-navigation ul.submenu {
  height: auto;
  max-height: 0;
  overflow: hidden;
  padding: 0;
  /* margin: 6px 14px 4px 18px; */
  background: rgba(0, 0, 0, 0.18);
  border-left: 2px solid #1a6ea8;
  border-radius: 0 0 6px 6px;
  transition: max-height 0.3s ease, padding 0.25s ease;
}

.has-submenu.open > ul.submenu {
  max-height: 460px;
  padding: 4px 0 6px;
}

.sidebar-navigation.collapsed ul.submenu {
  max-height: 0 !important;
  padding: 0 !important;
}

.submenu-item {
  padding: 8px 0;
  background-color: transparent;
  font-size: 0.85rem;
  color: #cce8f5;
}

.sidebar-navigation ul li.submenu-item:hover {
  background-color: rgba(26, 110, 168, 0.35);
  color: #ffffff;
}

.submenu-item .nav-icon {
  font-size: 0.85rem;
  color: #98d7ec;
}

.logo {
  width: 40px;
  height: 50px;
}

.logout {
  margin-top: auto !important;
}
</style>
